export default {
  name: "workkardListing",
  api: {
    endpoints: {
      tabCounts: "/1.0/getwktabcount",
      listView: "/1.0/cgcc",
      cardView: "/1.0/cgcc",
    },
  },
  params: {
    listView: {
      search: "key",
      skip: "skip",
      take: "take",
      rows: "rows",
      page: "page",
      status: "status",
      sortBy: "sortBy",
      sortDir: "sortDir",
    },
    cardView: {
      search: "key",
      skip: "skip",
      take: "take",
      rows: "rows",
      page: "page",
      status: "status",
      sortBy: "sortBy",
      sortDir: "sortDir",
    },
  },
};
